import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";
import service_contact_us from "../images/service-contact-us.png";

const WhatWeDoService = () => {
  const { id } = useParams();
  const { data, isLoading } = useQuery(["whatWeDoService"], async () => {
    const response = await window.fetch(
      `${BASE_URL}/service-slider-details/${id}`
    );
    return await response.json();
  });

  const { data: banner } = useQuery(["banner"], async () => {
    const response = await window.fetch(`${BASE_URL}/banner`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Helmet>
        <title>AFRO || Magazine</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={Boolean(banner?.banner?.default) ? "video" : "image"}
        videoURL={banner?.banner?.video}
        imageURL={banner?.banner?.image}
      >
        <div className="pt-7 pb-7 text-center">
          <h1 className="fs-56 gilroy-bold text-center text-white header-background-image-size">
            Service
          </h1>
        </div>
      </Header>
      <section className="container-fluid pt-5 pb-5">
        <div className="ms-47 me-47">
          <article>
            <div className="h-100 ">
              <div className="card-body p-md-5 fs-20">
                <div className="position-relative">
                  <img
                    src={`${IMAGE_BASE_URL}/${data?.service?.d_image}`}
                    // src={staticImage}
                    className="card-img-top w-full d-block service-image-banner"
                    loading="lazy"
                    alt="..."
                  />
                </div>
                <p className="fs-22 gilroy-bold text-charleston-green text-capitalize pt-5">
                  {data?.service?.title}
                </p>
                <p
                  className="fs-16 text-align-justify"
                  dangerouslySetInnerHTML={{
                    __html: data?.service?.description,
                  }}
                />

                {/* {data?.service?.service_country?.length && (
                  <>
                    <p className="fs-28 lh-40 gilroy-bold pt-5">
                      Available Countries
                    </p>
                    <ul className="fs-16 pb-3 text-dark">
                      {data?.service?.service_country?.map((country, index) => (
                        <li key={index}>{country?.name}</li>
                      ))}
                    </ul>
                  </>
                )} */}
              </div>
            </div>
          </article>
          <div className="d-flex justify-content-center">
            {/* <div className="d-flex justify-content-center align-items-center mb-0 px-2">
              <p className="bg-american-yellow mb-0 p-1">
                <img src={contact_us_icon} className="img-fluid" alt="" />
              </p>
              <p
                className="bg-american-yellow-light pb-0 mb-0 d-flex align-items-center"
                style={{ height: "5rem" }}
              >
                <Link
                  to="/contact-us"
                  className="fs-20 gilroy-bold text-white text-decoration-none px-4"
                >
                  Contact US
                </Link>
              </p>
            </div> */}
            <div>
              <Link to="/contact-us" className="">
                <img src={service_contact_us} className="img-fluid" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default WhatWeDoService;
